import { requireService } from '@profgeosoft/di-ez';
import { RadioButtonGroup } from '@repo/go-ui';

import { wrap } from 'src/packages/mobx-di/wrap';

import type { TAppLanguage } from 'src/services/localization-service.ts/types';

const LanguageSwitcher = wrap(function LanguageSwitcher() {
  const localizationService = requireService('localizationService');

  const handleSwitcherChange = (value: TAppLanguage) => {
    if (!value) {
      localizationService.setLocale(value);
    } else {
      localizationService.setLocale(value);
    }
  };

  return (
    <RadioButtonGroup
      size="m"
      value={localizationService.language}
      items={localizationService.languages}
      onChange={handleSwitcherChange}
    />
  );
});

export default LanguageSwitcher;
